export const getDatasetDisplayType = (inputString) => {
  // Split the input string by hyphen
  if (!inputString) return inputString

  const splitString = inputString.split('-')

  // Map the first letter of the first word to uppercase
  const firstWord = splitString[0].charAt(0).toUpperCase() + splitString[0].slice(1)

  // Join the rest of the words with a space separator
  const remainingWords = splitString.slice(1).join(' ')

  // Concatenate the first word and the remaining words
  const outputString = `${firstWord} ${remainingWords}`

  return outputString
}



// WEBPACK FOOTER //
// ./src/components/auditing/helpers.js